/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface StaffOnlinePerson
 */
export interface StaffOnlinePerson {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof StaffOnlinePerson
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof StaffOnlinePerson
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof StaffOnlinePerson
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof StaffOnlinePerson
     */
    role: string | null;
}

/**
 * Check if a given object implements the StaffOnlinePerson interface.
 */
export function instanceOfStaffOnlinePerson(value: object): value is StaffOnlinePerson {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function StaffOnlinePersonFromJSON(json: any): StaffOnlinePerson {
    return StaffOnlinePersonFromJSONTyped(json, false);
}

export function StaffOnlinePersonFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffOnlinePerson {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'role': json['role'],
    };
}

export function StaffOnlinePersonToJSON(json: any): StaffOnlinePerson {
    return StaffOnlinePersonToJSONTyped(json, false);
}

export function StaffOnlinePersonToJSONTyped(value?: StaffOnlinePerson | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'role': value['role'],
    };
}

